/**
 * HYCO Blog slider: Swiper with progress bar and arrow navigation.
 */

(function () {
  'use strict';

  const DESKTOP_BREAKPOINT = 990;

  /**
   * @param {object} swiper Swiper instance
   * @param {HTMLElement|null} prevEl
   * @param {HTMLElement|null} nextEl
   */
  function updateNavState(swiper, prevEl, nextEl) {
    if (!prevEl || !nextEl) {
      return;
    }

    const locked = swiper.isLocked;
    const atStart = swiper.isBeginning;
    const atEnd = swiper.isEnd;

    prevEl.disabled = locked || atStart;
    nextEl.disabled = locked || atEnd;
    prevEl.setAttribute(
      'aria-disabled',
      prevEl.disabled ? 'true' : 'false',
    );

    nextEl.setAttribute(
      'aria-disabled',
      nextEl.disabled ? 'true' : 'false',
    );

    prevEl.classList.toggle(
      'hyco-blog-slider__nav-btn--inactive',
      atStart,
    );

    nextEl.classList.toggle(
      'hyco-blog-slider__nav-btn--inactive',
      atEnd,
    );
  }

  /**
   * @param {HTMLElement} container Root [data-hyco-blog-slider]
   */
  function destroyIfNeeded(container) {
    const el = container.querySelector('.hyco-blog-slider__swiper');

    if (el && el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  /**
   * @param {HTMLElement} container Root [data-hyco-blog-slider]
   */
  function initBlogSlider(container) {
    const Swiper = window.Swiper;

    if (typeof Swiper !== 'function') {
      return;
    }

    const swiperEl = container.querySelector('.hyco-blog-slider__swiper');

    if (!swiperEl) {
      return;
    }

    const wrap = swiperEl.querySelector(':scope > .swiper-wrapper');

    if (!wrap || wrap.children.length === 0) {
      return;
    }

    destroyIfNeeded(container);

    const nextEl = container.querySelector('.hyco-blog-slider__nav-next');
    const prevEl = container.querySelector('.hyco-blog-slider__nav-prev');
    const paginationEl = container.querySelector(
      '.hyco-blog-slider__pagination',
    );

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 8,
      speed: 450,
      watchOverflow: true,
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
      breakpoints: {
        [DESKTOP_BREAKPOINT]: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
      },
      on: {
        afterInit(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
        slideChange(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
        resize(sw) {
          updateNavState(sw, prevEl, nextEl);
        },
      },
    });

    updateNavState(swiper, prevEl, nextEl);
  }

  /**
   */
  function bootAllRoots() {
    document
      .querySelectorAll('[data-hyco-blog-slider]')
      .forEach(function eachRoot(container) {
        initBlogSlider(container);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllRoots);
  } else {
    bootAllRoots();
  }

  document.addEventListener('shopify:section:load', function onSectionLoad(
    ev,
  ) {
    const container = ev.target.querySelector('[data-hyco-blog-slider]');

    if (container) {
      initBlogSlider(container);
    }
  });

  document.addEventListener('shopify:section:unload', function onSectionUnload(
    ev,
  ) {
    const container = ev.target.querySelector('[data-hyco-blog-slider]');

    if (container) {
      destroyIfNeeded(container);
    }
  });
})();
